import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RequestAd from './RequestAd';
import Adcount from './Adcount';
import AdCore from './AdCore';
import AdPause from './AdPause';
import AdPlaying from './AdPlaying';
import Adbanner from './Adbanner';
import Adcorner from './Adcorner';
import Events from '../event';
import Stat from '../vStat';

class AdVideo extends Component {
    static propTypes = {
        opt: PropTypes.object.isRequired,
        videoinfo: PropTypes.object.isRequired,
    };
    constructor(props) {
        super(props);
        this.opt = this.props.opt;
        this.opt = {
            containerDom: 'playerDiv',
            ...this.opt,
        };
        this.videoinfo = this.props.videoinfo;
        this.state = {
            showItem: false,
            isRender: false,
            renderCore: false,
            can: 'no',
            destory: false,
        };
        this.initMuted = false;
    }
    componentDidMount() {
        this.firstbuff = true; // 还剩n秒时标记

        const ad = new RequestAd(this.opt, this.videoinfo);
        let time = 0;

        const fun = (data, obj) => {
            clearInterval(this.timer);
            const dui = {
                ...data,
                obj,
            };

            if (typeof dui.frontAd !== 'undefined') {
                this.can = 'yes';
                this.setState({
                    can: 'yes',
                });
                this.initParams(dui);
                this.initComponent();
            } else {
                this.can = 'no';
                this.setState({
                    can: 'no',
                });
                this.setState({
                    isRender: true,
                });
            }
            // console.log('fun');
            this.trigger('start');
        };

        this.timer = setInterval(() => {
            time++;
            // console.log(time);
            if (time > 4) {
                ad.off('start', fun);
                this.can = 'no';
                this.trigger('start');
                this.trigger('ended', 5);
                clearInterval(this.timer);
            }
        }, 1000);
        // 监听回调

        ad.on('start', fun);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    initParams(obj) {
        this.RequestAd = Promise.resolve(obj);
    }

    initComponent() {
        const self = this;

        this.RequestAd.then((call) => {
            self.call = call;
            self.frontAd = call.frontAd;
            self.adTime = call.frontAd.adTime;
            self.banner = call.banner;
            self.corner = call.corner;
            self.obj = call.obj;
            self.setState({
                isRender: true,
            });
            self.Adcount = new Adcount(call.obj);
            // console.log('didMount');
            this.didMount();
        });

        // this.Adcount = this.RequestAd.then(call => {
        //     return new Adcount(call.obj);
        // });
    }
    didMount() {
        const vStat = new Stat(this.props.videoinfo);
        const AdCore = this.refs['adCore'];
        const AdPause = this.refs['adPause'];
        const Adbanner = this.refs['adbanner'];
        const Adcorner = this.refs['adcorner'];
        const AdPlaying = this.refs['adPlaying'];
        const Adcount = this.Adcount;

        const self = this;

        let playIndex = 0; // 应该播放的index  还有就是可以拿到的AdCore.dom
        let playflag = false; // 是否播放过

        const frontAd = this.frontAd;
        const adUrl = this.frontAd.adUrl; // 广告地址数组
        const adTime = this.frontAd.adTime; // 广告总时长
        let lastTime = adTime;

        // console.log(AdCore);
        AdCore.on(
            'canplay',
            () => {
                // console.log('canplay');
                if (playflag === false) {
                    AdCore.adPlay(0); // playIndex
                    AdPlaying.show();
                    vStat.sendVplayer('701010');
                }
                playflag = true;
                self.trigger('canplay');
            },
            AdCore.el[0],
        );

        AdCore.on('mutePlay', () => {
            this.initMuted = true;
            AdPlaying.adVideoMutedPlay();
        });

        // 广告内容绑定事件
        adUrl.forEach((element, index) => {
            let sendPlay = false;
            let first = true;

            AdCore.on(
                'timeupdate',
                () => {
                    if (first === true) {
                        vStat.sendAd('start', '000', frontAd, playIndex);
                        // self.trigger('firstPlay');
                        // ad开始播放后再调高音量
                        AdCore.adStartHVolume();

                        Adcount.send(1, playIndex, AdCore.dom.currentTime); // nb

                        first = false;
                    }

                    const _this = AdCore.el[index];

                    // 调用广告统计脚本，参数为video的index和currentTime

                    if (Math.floor(AdCore.dom.currentTime) === 3 && sendPlay === false) {
                        vStat.sendAd('play', '000', frontAd, playIndex);
                        sendPlay = true;
                    }

                    const second = Math.max(0, Math.round(lastTime - _this.currentTime));

                    document.getElementById('js_video_tip_number').innerHTML = `${second}s`;

                    if (index === adUrl.length - 1 && second === 3) {
                        if (self.firstbuff === true) {
                            self.trigger('adbuff');
                            self.firstbuff = false;
                        }
                    }
                },
                AdCore.el[index],
            );

            AdCore.on(
                'ended',
                () => {
                    const _this = AdCore.el[index];

                    lastTime = Math.max(0, Math.round(lastTime - _this.currentTime));
                    // 发送播放器广告播放完成统计
                    vStat.sendAd('finish', '000', frontAd, playIndex);

                    // console.log('lastTime:::::' + lastTime);
                    if (adUrl.length > 0 && playIndex + 1 < adUrl.length) {
                        AdCore.adPlay(++playIndex); // playIndex
                    } else if (playIndex + 1 === adUrl.length) {
                        // console.log('广告播完了');
                        this.trigger('ended', this.obj);
                    }
                },
                AdCore.el[index],
            );
        });

        const adVolume = AdPlaying.advolume;

        // 静音、取消静音
        adVolume.addEventListener('click', (e) => {
            AdCore.adVolume(AdCore.dom);
            if (this.initMuted) {
                AdCore.cancelVideoMuted();
                this.initMuted = false;
            }
            AdPlaying.videoTipVolumeMuteToggle();
        });

        // 查看广告详情
        AdPlaying.adlink.addEventListener('click', (e) => {
            // 发送播放器广告点击统计
            window.open(AdCore.clickUrl); // 核心
            vStat.sendAd('click', '000', frontAd, playIndex);
            Adcount.sendClick(1, playIndex);
        });

        AdPlaying.adlink2.addEventListener('click', (e) => {
            // 发送播放器广告点击统计
            window.open(AdCore.clickUrl); // 核心
            vStat.sendAd('click', '000', frontAd, playIndex);
            Adcount.sendClick(1, playIndex); // nb
        });

        // 点击会员去掉广告
        AdPlaying.advip.addEventListener('click', (e) => {
            AdPause.adVip();
            AdCore.dom.pause();
        });

        Adbanner.el.addEventListener('click', (e) => {
            if (typeof frontAd.banner == 'undefined') return;
            if (!frontAd.banner.goUrl) return;
            window.open(frontAd.banner.goUrl);
            e.stopPropagation();
            Adcount.sendClick(5, 0);
        });

        Adcorner.el.addEventListener('click', (e) => {
            if (typeof frontAd.corner == 'undefined') return;
            if (!frontAd.corner.goUrl) return;
            window.open(frontAd.corner.goUrl);
            e.stopPropagation();
            Adcount.sendClick(4, 0);
        });

        AdPause.pauseClose.addEventListener('click', (e) => {
            AdPause.adVipClose();
            AdCore.dom.play();
            e.stopPropagation();
            e.preventDefault();
        });

        AdPause.pauseLink.onclick = (e) => {
            window.open('//my.v.ifeng.com/user/vip?type=packagelist&to=ad');
            e.stopPropagation();
            e.preventDefault();
        };
    }

    cancleAdCoreMuted() {
        const AdCore = this.refs['adCore'];

        if (AdCore) {
            if (this.initMuted) {
                AdCore.cancelVideoMuted();
                this.initMuted = false;
            }
        } else {
            setTimeout(() => {
                this.cancleAdCoreMuted();
            }, 200);
        }
    }

    bannerAdShow() {
        const adbanner = this.refs['adbanner'];
        // console.log('adbanner==============>>>>', adbanner);

        if (typeof this.can == 'undefined' || this.can === 'no') return;
        const call = this.call;
        // call = {
        //     frontAd: { banner: { imgUrl: '//p1.ifengimg.com/a/2016/1021/pause.jpg?vip' } },
        // };
        const frontAd = call.frontAd;

        if (frontAd.banner) {
            let bannerimg = null;

            if (frontAd.banner.imgUrl.indexOf('.html') > -1) {
                // ifram的素材
                bannerimg = document.createElement('iframe');
                bannerimg.src = frontAd.banner.imgUrl;

                bannerimg.setAttribute('width', '100%');
                bannerimg.setAttribute('height', '100%');
                bannerimg.setAttribute('scrolling', 'no');
                bannerimg.setAttribute('frameborder', 'no');
                bannerimg.setAttribute('border', '0');
            } else {
                // 图片素材
                bannerimg = new Image();
                // bannerimg.src = "//p1.ifengimg.com/a/2016/1021/pause.jpg?vip";
                bannerimg.src = frontAd.banner.imgUrl;
            }
            const jsBanner = adbanner.el;

            jsBanner.insertBefore(bannerimg, jsBanner.childNodes[0]);
            adbanner.show();

            // 设置定时器，5s钟关闭banner广告
            this.bannerTimer = setTimeout(() => {
                adbanner.hide();
            }, 10000);

            // 发送banner广告统计，5为banner广告，index参数为0
            this.Adcount.send(5, 0);
        }
    }
    cornerAdShow() {
        const adcorner = this.refs['adcorner'];

        if (typeof this.can == 'undefined' || this.can === 'no') return;
        const call = this.call;
        // call = {
        //     frontAd: { corner: { imgUrl: '//p1.ifengimg.com/a/2016/1021/pause.jpg?vip' } },
        // };
        const Adcount = this.Adcount;
        const frontAd = call.frontAd;

        if (frontAd.corner) {
            const cornerimg = new Image();

            cornerimg.src = frontAd.corner.imgUrl;
            const jsCorner = adcorner.el;

            jsCorner.insertBefore(cornerimg, jsCorner.childNodes[0]);
            // $(jsCorner).removeClass('connerAdHide');
            adcorner.cornerShow();
            console.log('this.Adcount.send(4, 0)');
            // 发送暂停广告统计:4为角标广告，index为0
            Adcount.send(4, 0);
        }
    }
    pauseAdShow() {
        const adPause = this.refs['adPause'];

        this.AdPause = adPause;
        const oobj = {
            type: 'pause',
            adType: this.opt.adType || '5',
            subject: this.opt.subject || '',
            frmid: this.opt.frmid || 'free',
        };

        if (this.videoinfo.categoryId) {
            const ptype = this.videoinfo.categoryId.split('-')[0];

            if (ptype === '154') {
                oobj.adType = '4';
                oobj.frmid = 'vdocumentary';
            }
        }
        const ad = new RequestAd(oobj, this.videoinfo);

        ad.on('start', (data, obj) => {
            // let data = {
            //     materiaUrl: '//c1.ifengimg.com/iamsImg/2018/03/23/0a969e0dd9bd7c682e589ba11955a314_w300_h250.jpg',
            //     goUrl:
            //         '//iis1.deliver.ifeng.com/c?p=Z5Ak8dpljixX2bxXlYF-90ndztgDYCzN11NG89FYsj_KEKOAuZU3-W9mfsRvH66N9AoxEfHlWpyDiX1Hby9OnvXouYQrM542IRe8G30PVkt8eoMfDu0H3QS2Y8e_p46iGdyTRJXR6rktFbBRWgOWCDQoEMVtBt1M6-axm7hkI3uD9WgrdZ8Kkr6o3XHjuGKpz68GWgQR5sLiqwwzpeybzg',
            // };
            // let obj = {
            //     code: 1,
            //     info: [
            //         {
            //             type: 4, //暂停
            //             materialUrl:
            //                 '//c1.ifengimg.com/iamsImg/2018/03/23/0a969e0dd9bd7c682e589ba11955a314_w300_h250.jpg', //广告素材地址。
            //             duration: 0, //此段视频广告时长。角标，暂停广告为0.
            //             clickUrl:
            //                 '//iis1.deliver.ifeng.com/c?p=Z5Ak8dpljixX2bxXlYF-90ndztgDYCzN11NG89FYsj_KEKOAuZU3-W9mfsRvH66N9AoxEfHlWpyDiX1Hby9OnvXouYQrM542IRe8G30PVkt8eoMfDu0H3QS2Y8e_p46iGdyTRJXR6rktFbBRWgOWCDQoEMVtBt1M6-axm7hkI3uD9WgrdZ8Kkr6o3XHjuGKpz68GWgQR5sLiqwwzpeybzg', //广告跳转地址。
            //             eventlog: {},
            //         },
            //     ],
            // };
            const _Adcount = new Adcount(obj);
            const frontAd = data;

            if (typeof frontAd == 'undefined') return;
            if (!frontAd.materiaUrl) return;
            _Adcount.pauseAds = obj.info;
            adPause.adVip(frontAd.materiaUrl);

            adPause.pauseLink.onclick = (e) => {
                window.open(frontAd.goUrl);
                e.stopPropagation();
                e.preventDefault();
                _Adcount.sendClick(3, 0);
            };

            // 发送暂停广告统计:3为暂停广告，index为0
            _Adcount.send(3, 0);
        });
    }
    show = () => {
        this.setState({
            showItem: true,
        });
    };
    hide = () => {
        this.setState({
            showItem: false,
        });
    };
    getStyle = () => {
        return {
            width: '100%',
            height: '100%',
            position: 'absolute',
            display: this.state.showItem ? 'block' : 'none',
        };
    };
    play() {
        // this.el.play();
    }
    pause() {
        // this.el.pause();
    }
    destory() {
        this.setState({
            destory: true,
        });
    }
    render() {
        const { isRender, can, destory } = this.state;

        let renderChildren = destory
            ? [
                  <AdPause ref="adPause" key="adpause" />,
                  <Adbanner ref="adbanner" key="adbanner" />,
                  <Adcorner ref="adcorner" key="adcorner" />,
              ]
            : [
                  <AdCore ref="adCore" key="adcore" frontAd={this.frontAd} obj={1} />,
                  <AdPause ref="adPause" key="adpause" />,
                  <AdPlaying ref="adPlaying" key="adplaying" frontAd={this.frontAd} adTime={this.adTime} />,
                  <Adbanner ref="adbanner" key="adbanner" />,
                  <Adcorner ref="adcorner" key="adcorner" />,
              ];

        if (can === 'no') {
            renderChildren = [
                <AdPause ref="adPause" key="adpause" />,
                <Adbanner ref="adbanner" key="adbanner" />,
                <Adcorner ref="adcorner" key="adcorner" />,
            ];
        }

        if (!isRender) {
            renderChildren = null;
        }

        return renderChildren;
    }
}

Events.mixTo(AdVideo);
export default AdVideo;
